module.exports = __webpack_public_path__ + "images/logo.05d4ad70.svg";